import React from 'react'
import {formatCents, gaEvent} from 'shared'

export const ManageBox = (props) => {
  if (props.showManageBox === 'false') return null

  return <div className="generic-admin-box m-b-0">
    <div className="container">
      <div className="row p-y-md">
        <div className="col-md-12 offset-md-6 text-center">
          <h2 className="font-md">{I18n.t('fundraising_events.admin_boxes.show.headline')}</h2>
          <p>
            <a className="btn btn-large btn-primary m-b" href={props.manageUrl}>{I18n.t('fundraising_events.admin_boxes.show.manage_area_link')}</a>
          </p>
          <ForwardingNotice {...props} />
        </div>
        <TodoList {...props} />
      </div>
    </div>
  </div>
}

const ForwardingNotice = ({fundraisingEvent, manageForwardingUrl}) => {
  const availableCents = fundraisingEvent.donated_amount_in_cents - fundraisingEvent.forwarded_amount_in_cents
  if (availableCents === 0) return null

  return <p>
    <a href={manageForwardingUrl}>
      {I18n.t('fundraising_events.admin_boxes.show.forwarding_notice', {amount: formatCents(availableCents)})}
    </a>
  </p>
}

const TodoList = (props) => {
  if (props.showTodoList === 'false') return null

  if (props.category !== 'live_streams') {
    return <div className="offset-md-6 col-md-12 m-t-md">
      <div dangerouslySetInnerHTML={{__html: I18n.t('fundraising_events.admin_boxes.show.recent_registration_notice_html')}} />
        <ol>
          <li>
            <a onClick={() => gaEvent('navigation', 'click adminbox__add_picture_link')} href={props.manageNewPictureUrl}>{I18n.t('fundraising_events.admin_boxes.show.do_list_picture.link_text')}</a>
            {' '}{I18n.t('fundraising_events.admin_boxes.show.do_list_picture.list_item_html')}
          </li>
          <li>
            <a onClick={(event) => {
              event.preventDefault()
              gaEvent('engagement', 'click adminbox__share_it_link')
              document.querySelector('#share').scrollIntoView({behavior: 'smooth'})
            }} href="#share">{I18n.t('fundraising_events.admin_boxes.show.do_list_share.link_text')}</a>
            {' '}{I18n.t('fundraising_events.admin_boxes.show.do_list_share.list_item_html')}
          </li>
          <li>
            <a onClick={() => gaEvent('navigation', 'click adminbox__add_thank_you_message')} href={props.manageThankYouMessageUrl}>{I18n.t('fundraising_events.admin_boxes.show.do_list_thank_you_message.link_text')}</a>
            {' '}{I18n.t('fundraising_events.admin_boxes.show.do_list_thank_you_message.list_item_html')}
          </li>
        </ol>
      </div>

  } else {
    return <div className="offset-md-6 col-md-12 m-t-md">
      <div dangerouslySetInnerHTML={{ __html: I18n.t('fundraising_events.admin_boxes.show.recent_registration_notice_html') }} />
      <ol>
        <li>
          {I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.nickname_text_1')}{' '}
          <a onClick={() => gaEvent('navigation', 'click adminbox__add_nickname')} href={props.editUserUrl}>{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.nickname_link_text')}</a>
          {' '}{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.nickname_text_2')}
        </li>
        <li>
          <a onClick={() => gaEvent('navigation', 'click adminbox__configure_overlays')} href={props.manageLiveWidgetsUrl}>{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.overlay_link_text')}</a>
          {' '}{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.overlay_text')}
        </li>
        <li>
          <a onClick={() => gaEvent('navigation', 'click adminbox__streamer_blogpost_link')} href={I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.link_url')}>{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.link_text')}</a>
          {' '}{I18n.t('fundraising_events.admin_boxes.show.streamer_blogpost.list_item_html')}
        </li>
        <li>
          <a onClick={() => gaEvent('navigation', 'click adminbox__add_thank_you_message')} href={props.manageThankYouMessageUrl}>{I18n.t('fundraising_events.admin_boxes.show.do_list_thank_you_message.link_text')}</a>
          {' '}{I18n.t('fundraising_events.admin_boxes.show.do_list_thank_you_message.list_item_html')}
        </li>
      </ol>
    </div>
  }
}
